module.exports = __webpack_public_path__ + "static/media/hype-logo.9fa8f6d6.png";